export default "__VITE_ASSET__7e6d9763__"